/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Compare_Row_DwgInputs */

const en_cad_compare_row_dwg = /** @type {(inputs: Cad_Compare_Row_DwgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DWG files`)
};

/**
* | output |
* | --- |
* | "DWG files" |
*
* @param {Cad_Compare_Row_DwgInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_compare_row_dwg = /** @type {((inputs?: Cad_Compare_Row_DwgInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Compare_Row_DwgInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_compare_row_dwg(inputs)
});
export { cad_compare_row_dwg as "cad.compare.row_dwg" }